<div class="error-page">
  <div class="error-content">
    <h1 class="error-code">404</h1>
    <h2 class="error-title">Oops! Page Not Found</h2>
    <p class="error-message">
      The page you are looking for doesn’t exist or has been moved.
    </p>

    <!-- Illustration -->
    <img src="assets/images/404.png" alt="Not Found" class="error-image">

    <!-- Back Button -->
    <a routerLink="/" class="back-home">
      Go Back Home
    </a>
  </div>
</div>